import React, { Component } from 'react';
import { ReactComponent as DeleteButtonSvg } from '../../../images/delete-btn.svg';
import { ReactComponent as PlayButtonSvg } from '../../../images/play-btn.svg';
import { Button } from 'react-bootstrap';

export default class FlagsSelectedActions extends Component {
  constructor(props) {
    super(props);
  }

  handlePlayFlagsBtn = () => {
    this.props.handlePlayFlagsActionBtn();
  };

  playSelectedFlags = () => {
    return (
      <Button
        onClick={this.handlePlayFlagsBtn}
        id="flags-actions-play-selected"
        className={'flags-actions__btn-play-selected flags-actions-btn'}
        disabled={this.props.selectedItems.length === 0}
      >
        <PlayButtonSvg fill="#121212" />
        <span className="btn-play-selected__title">Play Selected</span>
      </Button>
    );
  };

  deleteSelectedFlags = () => {
    return (
      <Button
        onClick={() =>
          this.props.handleSelectedDelete(this.props.selectedItems)
        }
        id="flags-actions-delete-selected"
        className={'flags-actions__btn-delete-selected flags-actions-btn'}
        disabled={this.props.selectedItems.length === 0}
      >
        <DeleteButtonSvg />
        <span className="btn-delete-selected__title">Delete Selected</span>
      </Button>
    );
  };

  render() {
    return (
      <div className="selected-flags-actions-wrapper">
        {!this.props.hiddenSelectionCheckbox && this.playSelectedFlags()}
        {!this.props.hiddenSelectionCheckbox && this.deleteSelectedFlags()}
      </div>
    );
  }
}
